import React, { useEffect, useState } from 'react';
import {
  Form,
  Input,
  InputNumber,
  Button,
  Upload,
  message,
  Select,
  Typography,
  Row,
  Col,
  Alert,
} from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import axios from 'axios';

const { Dragger } = Upload;
const { Option } = Select;
const { Title } = Typography;

const ActualizarProducto = ({ productoSeleccionado,setModalVisible, fetchProductos  }) => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [categorias, setCategorias] = useState([]);
  const [marcas, setMarcas] = useState([]);
  const [talles, setTalles] = useState([]);
  const [generos, setGeneros] = useState([]);
  const [colores, setColores] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [usuarioId, setUsuarioId] = useState(null);

  console.log(productoSeleccionado)
  useEffect(() => {
    const storedId = localStorage.getItem('usuarioId');
    setUsuarioId(storedId);
  }, []);

  useEffect(() => {
    if (!usuarioId || !productoSeleccionado) return;

    const fetchData = async () => {
      try {
        const [catRes, marcaRes, talleRes, generoRes, colorRes] = await Promise.all([
          axios.get('https://elarigestion-production.up.railway.app/api/categorias', { params: { usuarioId } }),
          axios.get('https://elarigestion-production.up.railway.app/api/marcas', { params: { usuarioId } }),
          axios.get('https://elarigestion-production.up.railway.app/api/talles', { params: { usuarioId } }),
          axios.get('https://elarigestion-production.up.railway.app/api/generos', { params: { usuarioId } }),
          axios.get('https://elarigestion-production.up.railway.app/api/colores'),
        ]);

        setCategorias(catRes.data);
        setMarcas(marcaRes.data);
        setTalles(talleRes.data);
        setGeneros(generoRes.data);
        setColores(colorRes.data);

        form.setFieldsValue({
          nombre: productoSeleccionado.nombre,
          descripcion: productoSeleccionado.descripcion,
          precio: productoSeleccionado.precio,
          stock: productoSeleccionado.stock,
          categoriaId: productoSeleccionado.categoriaId,
          marcaId: productoSeleccionado.marcaId,
          generoId: productoSeleccionado.generoId,
       talleIds: productoSeleccionado.talles.map((t) => t.ProductoTalle.TalleId),
  colorIds: productoSeleccionado.colores.map((c) => c.ProductoColor.ColorId),


        });
      } catch (err) {
        console.error(err);
        setErrorMessage('Error al cargar los datos.');
      }
    };

    fetchData();
  }, [usuarioId, productoSeleccionado, form]);

  const onFinish = async (values) => {
        const token = localStorage.getItem('token');

    setSubmitLoading(true);
    setErrorMessage(null);
    setSuccessMessage(null);

    const formData = new FormData();
    formData.append('nombre', values.nombre);
    formData.append('descripcion', values.descripcion || '');
    formData.append('precio', values.precio);
    formData.append('stock', values.stock);
    formData.append('usuarioId', usuarioId);
    formData.append('categoriaId', values.categoriaId);
    formData.append('marcaId', values.marcaId);
     formData.append('talleIds', JSON.stringify(values.talleIds));
    formData.append('generoId', values.generoId);
    formData.append('colorIds', JSON.stringify(values.colorIds));

    if (fileList.length > 0) {
      formData.append('file', fileList[0]);
    }

    try {
      await axios.put(`https://elarigestion-production.up.railway.app/api/editar-productos/${productoSeleccionado.id}`, formData, {
      headers: {
                    Authorization: token,
                    'Content-Type': 'multipart/form-data',
                },
      });
      setSuccessMessage('Producto actualizado correctamente.');
      setModalVisible(false)
      fetchProductos()
    } catch (err) {
      setModalVisible(true)
      const msg = err.response?.data?.message || err.message || 'Error desconocido';
      setErrorMessage(msg);

    } finally {
      setSubmitLoading(false);
    }
  };

  const uploadProps = {
    beforeUpload: (file) => {
      setFileList([file]);
      return false;
    },
    onRemove: () => setFileList([]),
    fileList,
    accept: 'image/*',
    maxCount: 1,
  };

  return (
    <div style={{ maxWidth: 700, margin: '0 auto', padding: 24 }}>
  

   

      <Form layout="vertical" form={form} onFinish={onFinish}>

        <Form.Item>
          <Dragger {...uploadProps}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Arrastra o haz clic para subir una imagen</p>
            <p className="ant-upload-hint">Solo se permite una imagen.</p>
          </Dragger>
        </Form.Item> 
        <Form.Item label="Nombre" name="nombre" rules={[{ required: true, message: 'Ingresa un nombre' }]}>
          <Input />
        </Form.Item>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Precio" name="precio" rules={[{ required: true, message: 'Ingresa el precio' }]}>
              <InputNumber min={0} style={{ width: '100%' }} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Stock" name="stock" rules={[{ required: true, message: 'Ingresa el stock' }]}>
              <InputNumber min={0} style={{ width: '100%' }} />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item label="Categoría" name="categoriaId" rules={[{ required: true }]}>
          <Select>
            {categorias.map((c) => (
              <Option key={c.id} value={c.id}>
                {c.nombre}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Marca" name="marcaId" rules={[{ required: true }]}>
          <Select>
            {marcas.map((m) => (
              <Option key={m.id} value={m.id}>
                {m.nombre}
              </Option>
            ))}
          </Select>
        </Form.Item>

   

        <Form.Item label="Género" name="generoId" rules={[{ required: true }]}>
          <Select>
            {generos.map((g) => (
              <Option key={g.id} value={g.id}>
                {g.nombre}
              </Option>
            ))}
          </Select>
        </Form.Item>

<Form.Item label="Talle" name="talleIds" >
  <Select mode="multiple" placeholder="Selecciona los talles">
    {talles.map((t) => (
      <Option key={t.id} value={t.id}>
        {t.nombre}
      </Option>
    ))}
  </Select>
</Form.Item>

<Form.Item label="Colores" name="colorIds" rules={[{ required: true }]}>
  <Select mode="multiple" placeholder="Selecciona los colores">
    {colores.map((c) => (
      <Option key={c.id} value={c.id}>
        {c.nombre}
      </Option>
    ))}
  </Select>
</Form.Item>

   {errorMessage && (
        <Alert
          description={errorMessage}
          type="error"
          showIcon
          closable
          onClose={() => setErrorMessage(null)}
          style={{ marginBottom: 16 }}
        />
      )}

   {/*    {successMessage && (
        <Alert
          description={successMessage}
          type="success"
          showIcon
          closable
          onClose={() => setSuccessMessage(null)}
          style={{ marginBottom: 16 }}
        />
      )} */}
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={submitLoading} block>
            Actualizar Producto
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ActualizarProducto;
